/**
 * --------------------------------------------------------------------------
 * CoreUI PRO data-grid engine/features-lite.ts
 * License (https://coreui.io/pro/license/)
 * --------------------------------------------------------------------------
 */

import {
  columnFilteringFeature,
  createFilteredRowModel,
  createPaginatedRowModel,
  createSortedRowModel,
  filterFn_includesString as includesStringFilterFn,
  globalFilteringFeature,
  rowPaginationFeature,
  rowSortingFeature,
  sortFn_alphanumeric as alphanumericSortFn,
  sortFn_datetime as datetimeSortFn,
  sortFn_text as textSortFn,
  tableFeatures
} from '@tanstack/table-core'
import { storeReactivityBindings } from '@tanstack/table-core/store-reactivity-bindings'

// The smallest set the grid renders with: sorting, filtering (incl. the
// toolbar search) and pagination. Everything column-shape related (visibility,
// ordering, pinning, sizing) and selection/faceting stays out - the grid
// falls back to core APIs for those. sortFns/filterFns stay in so a lite grid
// sorts and searches exactly like a full one. Kept in its own module so the
// lite bundle entry never reaches the full set.
export const dataGridLiteFeatures = tableFeatures({
  coreReactivityFeature: storeReactivityBindings(),
  columnFilteringFeature,
  globalFilteringFeature,
  rowPaginationFeature,
  rowSortingFeature,
  filteredRowModel: createFilteredRowModel(),
  paginatedRowModel: createPaginatedRowModel(),
  sortedRowModel: createSortedRowModel(),
  filterFns: { includesString: includesStringFilterFn },
  sortFns: {
    alphanumeric: alphanumericSortFn,
    datetime: datetimeSortFn,
    text: textSortFn
  }
})

export type DataGridLiteFeatures = typeof dataGridLiteFeatures
